module.exports = __webpack_public_path__ + "c041de789387fc5bbc8a477f7bafd92c.png";